import { render, staticRenderFns } from "./ArchiveUserModal.vue?vue&type=template&id=2e4ea366&scoped=true&"
import script from "./ArchiveUserModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4ea366",
  null
  
)

export default component.exports